import React from 'react';
import { Form } from 'react-form';
import { connect } from 'react-redux';
import Translate from 'translate';

import AuthService from 'services/AuthService';
import UserService from 'services/UserService';
import ChatService from 'services/ChatService';
import { FormGroup, Text } from 'components/FormElements';
import WebsocketComp from 'components/Websocket';
import { toggleAlertError, toggleLoading } from 'stores/actions';

class Websocket extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      websocketOpen: false,
      message: null,
    }
  }

  submitForm = ( data ) => {
    const { toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    this.setState( { message: data.message } )

    UserService.sendMessage( data ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );
    } )
  };

  initChat = ( data ) => {
    const { toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    ChatService.login().then( ( response ) => {
      if( response.errors ) {
        toggleLoading( false );
        return toggleAlertError( response.errors );
      }

      ChatService.registerChannel( response.data.access_token, {
        ...data,
        phoneNumber: null
      } ).then( ( wResponse ) => {
        toggleLoading( false );
        if( wResponse.errors ) return toggleAlertError( wResponse.errors );
        this.websocketData = wResponse.data;
        this.setState( { websocketOpen: true } )
      } )
    } )
  };

  render() {
    const { websocketOpen, message } = this.state;

    return (
      <div className="page-login">
        <div className="main-body pt-5">
          <div className="body-inner">
            <div className="card bg-white">
              <div className="card-content">
                <Form onSubmit={this.initChat}>
                  {( { submitForm } ) =>
                    <form onSubmit={submitForm}>
                      <div className="form-group mt-3">
                        <Text field="name" placeholder="name" className="form-control"/>
                        <Text field="email" placeholder="email" className="form-control mt-2"/>
                        <Text field="subject" placeholder="subject" className="form-control mt-2"/>
                      </div>

                      <div className="text-right mt-3">
                        <button className="btn btn-info text-uppercase mr-2">
                          Init
                        </button>
                      </div>
                    </form>
                  }
                </Form>
              </div>
            </div>
          </div>
          <div className="body-inner">
            <div className="card bg-white">
              <div className="card-content">

                <Form onSubmit={this.submitForm}>
                  {( { submitForm } ) =>
                    <form onSubmit={submitForm}>
                      <div className="form-group mt-3">
                        <Text field="message" className="form-control"/>
                      </div>

                      <div className="text-right mt-3">
                        <button type="button" className="btn btn-info text-uppercase mr-2" onClick={() => {
                          this.setState( { websocketOpen: !websocketOpen } )
                        }}>
                          {websocketOpen ? 'Close' : 'Open'}
                        </button>
                        <button type="submit" className="btn btn-info text-uppercase">
                          Chat
                        </button>
                      </div>

                    </form>
                  }
                </Form>
              </div>
            </div>
          </div>
        </div>

        <WebsocketComp open={websocketOpen} data={this.websocketData} message={message}/>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( Websocket );



// WEBPACK FOOTER //
// ./routes/app/routes/websocket/index.js